import type { RouteObject } from "react-router-dom";

/** Standalone people routes are composed outside AdminPortalLayout, just like message drill-down pages. */
export const adminPeopleDetailRoutes: RouteObject[] = [
  {
    path: "admin/people/classrooms/:classroomId/print",
    lazy: async () =>
      (
        await import("@/features/admin-people/route")
      ).loadClassroomReportPrintRoute(),
  },
  {
    path: "admin/people/students/:studentId/print",
    lazy: async () =>
      (
        await import("@/features/admin-people/route")
      ).loadStudentReportPrintRoute(),
  },
  {
    path: "admin/people/grades/:gradeId",
    lazy: async () =>
      (await import("@/features/admin-people/route")).loadGradeDetailsRoute(),
  },
  {
    path: "admin/people/classrooms/:classroomId",
    lazy: async () =>
      (
        await import("@/features/admin-people/route")
      ).loadClassroomDetailsRoute(),
  },
  {
    path: "admin/people/staff/:personId",
    lazy: async () =>
      (await import("@/features/admin-people/route")).loadStaffDetailsRoute(),
  },
  {
    path: "admin/people/students/:studentId",
    lazy: async () =>
      (await import("@/features/admin-people/route")).loadStudentDetailsRoute(),
  },
];
